export enum PATHS {
  Referral = "/referral",

  Login = "/login",
  Register = "/register",
  ForgetPassword = "/forget-password",
  ResetPassword = "/reset-password",
}
